import { useEffect } from "react";

const DEFAULTS = {
  siteName: "Kiwami Studios & Co",
  defaultTitle:
    "Kiwami Studios & Co — Photographie premium : BTP, Événementiel, Sport, Corporate, Publicité, Formation",
  defaultDescription:
    "Studio de photographie premium spécialisé en BTP, événementiel, sport, corporate, publicité de marque et formation photo. Devis sous 24h.",
  defaultImage: "/api/uploads/branding/og-image.jpg",
  type: "website",
};

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", String(content));
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets document.title, OG tags, Twitter card meta, and canonical URL.
 * Call once per page, ideally at the top of each route component.
 */
export function useSEO({ title, description, image, lang } = {}) {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const finalTitle = title
      ? `${title} · ${DEFAULTS.siteName}`
      : DEFAULTS.defaultTitle;
    const finalDescription = description || DEFAULTS.defaultDescription;
    const origin = window.location.origin || "";
    const finalImage = image
      ? image.startsWith("http")
        ? image
        : `${origin}${image}`
      : `${origin}${DEFAULTS.defaultImage}`;
    const canonical = origin + window.location.pathname;

    document.title = finalTitle;
    setMeta("description", finalDescription);

    // Open Graph
    setMeta("og:type", DEFAULTS.type, "property");
    setMeta("og:site_name", DEFAULTS.siteName, "property");
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", finalDescription, "property");
    setMeta("og:image", finalImage, "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:locale", lang === "en" ? "en_US" : "fr_FR", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDescription);
    setMeta("twitter:image", finalImage);

    // Canonical
    setLink("canonical", canonical);
  }, [title, description, image, lang]);
}
